import { Component } from '@angular/core';
import { map } from 'rxjs/operators';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { NavigationService } from "../shared/services/navigation.service";

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent {

  private _columnNum = 5;
  private _cards;

  constructor(private breakpointObserver: BreakpointObserver, navigationService: NavigationService) {
    this._cards = this.breakpointObserver.observe([Breakpoints.HandsetPortrait]).pipe(
      map(() => navigationService.dashboardNavItems.map(navItem => ({
        title: navItem.title, cols: 1, rows: 1, routerLink: navItem.routerLink, icon: navItem.icon
      })))
    );
  }

  ngOnInit() {
    this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium])
      .subscribe(() => {
        if (this.breakpointObserver.isMatched([Breakpoints.XSmall])) {
          this._columnNum = 1;
        } else if (this.breakpointObserver.isMatched([Breakpoints.Small])) {
          this._columnNum = 2;
        } else if (this.breakpointObserver.isMatched([Breakpoints.Medium])) {
          this._columnNum = 3;
        } else {
          this._columnNum = 5;
        }
      })
  }

  public get columnNum(): number {
    return this._columnNum;
  }

  public get cards() {
    return this._cards;
  }
}
